import React, { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ButtonToolbar from '../../../components/ButtonToolbar'
import { StoreState } from '../../../store'

import { TransactionsActionTypes } from '../../../store/transactions/transactionsTypes'

// material-ui
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'

import AddIcon from '@material-ui/icons/Add'
import FilterListIcon from '@material-ui/icons/FilterList'
import PrintIcon from '@material-ui/icons/Print'
import { useMediaQuery } from '@material-ui/core'

import { StyledMenu } from './style'
import { ResumeExcel } from './ResumeExcel'
import { Fieldset } from './Fieldset'
import { Resume } from './Resume'
import { ResumeAccumulated } from './ResumeAccumulated'

// types
interface Props {
  categories: any[]
}
type PropsEvent = ChangeEvent<{ value: unknown }>
type PropsPrintType = 'Extrato' | 'Relatório'

export default function TransactionsToolbar({ categories }: Props) {
  const dispatch = useDispatch()
  const matches = useMediaQuery('(min-width: 600px)')

  const { filters } = useSelector(({ transactionsState }: StoreState) => ({
    filters: transactionsState.filters,
  }))
  const [category, setCategory] = React.useState([
    {
      value: '',
      name: '',
    },
  ])

  const churchId = useSelector(({ sessionState }: StoreState) => {
    return sessionState.user?.churches[sessionState.selectedChurchIndex]?.id
  })

  const [state, setState] = useState({
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
    type: filters.type,
    resource: filters.resource,
    category: filters.category,
  })

  const [isOpenModalFilter, setOpenModalFilter] = useState(false)
  const [printType, setPrintType] = useState<PropsPrintType>('Extrato')
  const [showDetailsInPrint, setShowDetailsInPrint] = useState(false)
  const [openModalTithing, setOpenModalTithing] = useState(false)
  const [openModalExcel, setOpenModalExcel] = useState(false)

  useEffect(() => {
    setState(filters)
  }, [categories, filters, isOpenModalFilter])

  const onChangeFilterState = (key: string) => (event: PropsEvent) => {
    let content = event.target.value

    if (key === 'type') {
      let categoryValue = categories
        .filter((item) => item.active && item.type === content)
        .map((item) => ({ name: item.name, value: item.id }))

      setCategory(categoryValue)
      setState({ ...state, category: 'all', [key]: content as string })
    } else {
      setState({ ...state, [key]: content })
    }
  }

  /**
   * Impressão de extrato
   */
  const [isOpenModalPrint, setOpenModalPrint] = useState(false)
  const [printState, setPrintState] = useState({
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
    category: '',
  })

  const onChangePrintState = (key: string) => (event: PropsEvent) => {
    setPrintState({ ...printState, [key]: event.target.value })
  }

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <div>
        <ButtonToolbar
          text="Novo cadastro"
          IconLeft={AddIcon}
          matches={matches}
          onClick={() =>
            dispatch({ type: TransactionsActionTypes.EDITING_START })
          }
        />

        <ButtonToolbar
          text="Filtrar"
          IconLeft={FilterListIcon}
          matches={matches}
          onClick={() => setOpenModalFilter(true)}
        />
        <Button
          aria-controls="customized-menu"
          aria-haspopup="true"
          variant="outlined"
          onClick={handleClick}
          style={{
            width: matches ? 180 : '100%',
            marginBottom: matches ? 0 : 6,
            marginRight: matches ? 12 : 0,
            textTransform: 'none',
          }}
        >
          <PrintIcon
            style={{
              marginRight: 4,
              color: '#555',
            }}
          />
          Relatórios
        </Button>
        <StyledMenu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <Box display="flex" justifyContent="center" marginTop="6px">
            <Button
              variant="outlined"
              style={{
                width: matches ? 180 : 300,
                marginBottom: matches ? 0 : 6,
                textTransform: 'none',
              }}
              onClick={() => {
                setPrintType('Extrato')
                setOpenModalPrint(true)
              }}
            >
              <PrintIcon
                style={{
                  marginRight: 4,
                  color: '#555',
                }}
              />
              Extrato
            </Button>
          </Box>

          <Box display="flex" justifyContent="center" marginTop="6px">
            <Button
              variant="outlined"
              style={{
                width: matches ? 180 : 300,
                marginBottom: matches ? 0 : 6,
                textTransform: 'none',
              }}
              onClick={() => setOpenModalTithing(true)}
            >
              <PrintIcon
                style={{
                  marginRight: 4,
                  color: '#555',
                }}
              />
              Relatório E/S
            </Button>
          </Box>

          <Box display="flex" justifyContent="center" marginTop="6px">
            <Button
              variant="outlined"
              style={{
                width: matches ? 180 : 300,
                marginBottom: matches ? 0 : 6,
                textTransform: 'none',
              }}
              onClick={() => {
                setPrintType('Relatório')
                setOpenModalPrint(true)
              }}
            >
              <PrintIcon
                style={{
                  marginRight: 4,
                  color: '#555',
                }}
              />
              Relatório geral
            </Button>
          </Box>

          <Box display="flex" justifyContent="center" marginTop="6px">
            <Button
              variant="outlined"
              style={{
                width: matches ? 180 : 300,
                marginBottom: matches ? 0 : 6,
                textTransform: 'none',
              }}
              onClick={() => {
                setOpenModalExcel(true)
              }}
            >
              <PrintIcon
                style={{
                  marginRight: 4,
                  color: '#555',
                }}
              />
              Relatório Excel
            </Button>
          </Box>
        </StyledMenu>
      </div>

      <Fieldset
        category={category}
        dispatch={dispatch}
        isOpenModalFilter={isOpenModalFilter}
        onChangeFilterState={onChangeFilterState}
        setOpenModalFilter={setOpenModalFilter}
        state={state}
      />

      <Resume
        printState={printState}
        matches={matches}
        churchId={churchId}
        showDetailsInPrint={showDetailsInPrint}
        setOpenModalPrint={setOpenModalPrint}
        printType={printType}
        isOpenModalPrint={isOpenModalPrint}
        onChangePrintState={onChangePrintState}
        setShowDetailsInPrint={setShowDetailsInPrint}
      />

      <ResumeAccumulated
        setOpenModalTithing={setOpenModalTithing}
        onChangeFilterState={onChangeFilterState}
        openModalTithing={openModalTithing}
        categories={categories}
        category={category}
        churchId={churchId}
        state={state}
        dispatch={dispatch}
        setState={setState}
        filters={filters}
        matches={matches}
      />

      <ResumeExcel
        categories={categories}
        openModalExcel={openModalExcel}
        setOpenModalExcel={setOpenModalExcel}
      />
    </>
  )
}
